export default {
    packages_delete_package_title: "Borrar paquete",
    packages_delete_package_description: "¿Está seguro de que quiere eliminar el paquete?",
    packages_delete_package_success_message: "El paquete ha sido eliminado",
    packages_delete_package_error_message: "No ha sido posible eliminar el paquete debido a un error",
    packages_delete_package_in_use: "El paquete está vinculado a algunos usuarios, cambie el paquete de los usuarios y vuelva a intentarlo",
}